module.exports = __webpack_public_path__ + "static/media/dimpact_logo.fa83cdfd.jpeg";